import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { PaginatedResultModel, ShortModel } from '@data-layer/models/common';
import { CouponFormModel, CouponsSearchPagination } from '@app/modules/coupons-management/models';
import { ManagementCouponModel } from '../models/management/coupons';

@Injectable({ providedIn: 'root' })
export class CouponsManagementRepository {
  constructor(private apiService: ApiService) {}

  public search(params: CouponsSearchPagination): Observable<PaginatedResultModel<ManagementCouponModel>> {
    return this.apiService.get<PaginatedResultModel<ManagementCouponModel>>(
      `${environment.url.prefixCustoms}v2/management/discounts`,
      {
        params,
      },
      { isShowLoader: false },
    );
  }

  public get(id: number): Observable<ManagementCouponModel> {
    return this.apiService.get<ManagementCouponModel>(
      `${environment.url.prefixCustoms}v2/management/discounts/${id}`,
      {},
      { isShowLoader: true },
    );
  }

  public create(form: CouponFormModel): Observable<ManagementCouponModel> {
    return this.apiService.post<ManagementCouponModel>(
      `${environment.url.prefixCustoms}v2/management/discounts`,
      form,
      {},
      { isShowLoader: false },
    );
  }

  public update(id: number, payload: CouponFormModel): Observable<ManagementCouponModel> {
    return this.apiService.put<ManagementCouponModel>(
      `${environment.url.prefixCustoms}v2/management/discounts/${id}`,
      payload,
      {},
      { isShowLoader: true },
    );
  }

  public delete(id: number): Observable<void> {
    return this.apiService.delete<void>(`${environment.url.prefixCustoms}v2/management/discounts/${id}`, {}, { isShowLoader: true });
  }

  public changeActivityStatus(id: number, status: boolean): Observable<void> {
    return this.apiService.post<void>(
      `${environment.url.prefixCustoms}v2/management/discounts/${id}/active`,
      status,
      {},
      { isShowLoader: true },
    );
  }

  public getDiscountCategories(isShowLoader: boolean): Observable<ShortModel[]> {
    return this.apiService.get<ShortModel[]>(`${environment.url.prefixCustoms}v2/management/discount-categories`, {}, { isShowLoader });
  }
}
